module.exports = new __parcel__URL__("dark_matter_icon.a0b82354.png").toString();